import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommunicators } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const CommunicatorList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector(
    (state) => state.communicator.communicators
  );
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchCommunicators({ page, limit }));
    }
  }, [dispatch, page, user]);

  const navigateToCommunicatorDetail = (id) => {
    navigate(`/communicators/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderCommunicators = () =>
    rows.map((communicator) => (
      <TableRow
        key={communicator.chipID}
        onClick={() => navigateToCommunicatorDetail(communicator.id)}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{communicator.id}</TableCell>
        <TableCell>{communicator.chipID}</TableCell>
        <TableCell>{communicator.name}</TableCell>
        {/* <TableCell>{communicator.Organization.displayName}</TableCell> */}
        <TableCell>
          {new Date(communicator.createdAt).toLocaleString()}
        </TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            안전장비
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="communicator-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>칩 ID</TableCell>
                  <TableCell>감지기명</TableCell>
                  {/* <TableCell>건설사</TableCell> */}
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderCommunicators()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/communicators/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default CommunicatorList;
